/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import LoadingPage from "components/common_components/LoadingPage";
import { useDispatch } from "react-redux";
import { notifyError } from "redux/actions/Notifications";
import clsx from "clsx";
import Button from "components/common_components/Button";
import Icon from "components/common_components/Icon";
import EnhancedTable from "components/common_components/Tables/EnhancedTable";
import { hasElements } from "utils/arrays";
import FormsContext from "../FormsContext";
import { clientFileCaseColumns } from "./fileCaseColumns";

/** Optional step: pick one of the selected client's cases, or continue without one. */
const FileCases = ({ client, visible, onBackClick, onFileCaseSelected }) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const { FormClients } = useContext(FormsContext);

    useEffect(() => {
        if (visible && client?.id) {
            setIsLoading(true);
            FormClients.fileCases.getByClientId({
                clientId: client.id,
                onSuccess: (data) => {
                    setData(data);
                    setIsLoading(false);
                },
                onError: (error) => {
                    dispatch(notifyError(error));
                    setIsLoading(false);
                },
            });
        } else {
            setData([]);
        }
    }, [visible, client?.id]);

    return (
        <div
            className={clsx("layout clients-container", {
                visible: visible,
                invisible: !visible,
            })}
        >
            {visible && (
                <>
                    <Button secondary link onClick={onBackClick}>
                        <Icon name="arrow" color="secondary" size="xs" />
                        <span>Back</span>
                    </Button>
                    <hr />
                    <div className="step-title">
                        <h3>{`${client?.fullName}'s Case`}</h3>
                        <Button secondary outline small onClick={() => onFileCaseSelected(null)} disabled={isLoading}>
                            <span>Continue without a case</span>
                        </Button>
                    </div>
                    <small>
                        <i>Optionally, select the case this form belongs to</i>
                    </small>

                    <div className="clients">
                        {isLoading && <LoadingPage />}
                        {!isLoading && hasElements(data) && (
                            <EnhancedTable
                                headCells={clientFileCaseColumns}
                                data={data}
                                dense={false}
                                keyColumnName="fileCaseKey"
                                selectable={false}
                                deletable={false}
                                filterable={false}
                                orderable={false}
                                pageable={false}
                                onRowClick={onFileCaseSelected}
                            />
                        )}
                        {!isLoading && !hasElements(data) && (
                            <p className="empty-file-cases">
                                <i>This client has no cases.</i>
                            </p>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

FileCases.propTypes = {
    client: PropTypes.object,
    visible: PropTypes.bool,
    onBackClick: PropTypes.func,
    onFileCaseSelected: PropTypes.func,
};

FileCases.defaultProps = {
    client: {},
    visible: false,
    onBackClick: () => {},
    onFileCaseSelected: () => {},
};

export default FileCases;
